import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import { getKeyOfTruth } from "../utils/objectUtils";
import { DAY_VARIANTS } from "./constants";

dayjs.extend(isBetween);

export const getDayVariant = ({
  dayObj,
  todayDate,
  hoveredDate,
  selectedDate,
  selectedDates,
}) => {
  const hasRange = selectedDates?.length > 0;

  let variantObj;

  if (hasRange) {
    const [sDt, eDt] = selectedDates;
    const isStart = sDt && dayObj.isSame(sDt, "D");
    const isEnd = eDt && dayObj.isSame(eDt, "D");
    const isBetweenDt =
      dayObj.isBetween(sDt, eDt, "D") ||
      (dayObj.isAfter(sDt, "D") &&
        dayObj.isBefore(hoveredDate, "D") &&
        !eDt.isValid()) ||
      (dayObj.isBefore(eDt, "D") &&
        dayObj.isAfter(hoveredDate, "D") &&
        !sDt.isValid());

    const isToday =
      !isStart && !isEnd && !isBetweenDt && dayObj.isSame(todayDate, "D");

    variantObj = {
      [DAY_VARIANTS.TODAY]: isToday,
      [DAY_VARIANTS.START]: isStart,
      [DAY_VARIANTS.END]: isEnd,
      [DAY_VARIANTS.BETWEEN]: isBetweenDt,
    };
  } else {
    const isSelected = dayObj.isSame(selectedDate, "D");
    const isToday = !isSelected && dayObj.isSame(todayDate, "D");

    variantObj = {
      [DAY_VARIANTS.TODAY]: isToday,
      [DAY_VARIANTS.SELECTED]: isSelected,
    };
  }

  return getKeyOfTruth(variantObj);
};
